var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconopenPaperclip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.4,
    height: 24.513,
    viewBox: "0 0 21.4 24.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-paperclip",
    "data-name": "Icon open-paperclip",
    d: "M15.346,0a6.245,6.245,0,0,0-4.324,1.81L2.5,10.152a8.415,8.415,0,0,0,11.9,11.9l3.834-3.834L16.113,16.1l-3.558,3.466-.276.4a5.389,5.389,0,0,1-7.668-7.575l8.526-8.434a3.166,3.166,0,0,1,4.416,0,3.111,3.111,0,0,1,0,4.324L9.886,15.856a.824.824,0,0,1-1.165-1.165l.184-.092L11.7,11.716,9.58,9.6,6.6,12.575a3.8,3.8,0,0,0,5.367,5.367l7.668-7.483A6.119,6.119,0,0,0,15.315.031Z",
    transform: "translate(-0.034)",
    fill: "#51595e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconopenPaperclip);
export default __webpack_public_path__ + "static/media/Icon open-paperclip.ea8df2ffbe642e5a95a5bdc1286b3165.svg";
export { ForwardRef as ReactComponent };